import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from "./ErrorPage";
import { ConfirmPage } from "./ConfirmPage";
import { TemplateWrapper } from "@/templates/TemplateWrapper";
import { useConfirmationPage } from "@/contexts/confirmPage";
export const CdpRoot = (pageProps) => {
    const { showConfirm } = useConfirmationPage();
    if (showConfirm)
        return _jsx(ConfirmPage, {});
    if (pageProps.error) {
        return (_jsx(ErrorPage, { status: pageProps.error.status, code: pageProps.error.code }));
    }
    return _jsx(TemplateWrapper, {});
};
